import client from '../client/client'

// Sends SMS messages to multiple recipients
// Expects form-data: numbers (comma-separated), text (string)
const sendSmsRequest = async (numbersCsv: string, text: string) => {
  try {
    const formData = new FormData()
    formData.append('numbers', numbersCsv)
    formData.append('text', text)
    return await client.post('api/v1/admin/send-sms', formData)
  } catch (error) {
    return error
  }
}

export {sendSmsRequest}


